import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';

/**
 * Left side of common assessment card
 * * contains title, result, and description of metric
 */

interface DescriptionProps {
  title: string;
  explanation: string;
  result: React.ReactNode;
  loading: boolean;
}

export default function Description({
  explanation,
  loading,
  result,
  title,
}: DescriptionProps) {
  return (
    <ContentLoader loading={loading}>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent={'space-between'}
      >
        <Typography fontWeight="bold" variant="h6">
          {title}
        </Typography>

        {result}
      </Stack>

      <Divider
        sx={({ palette }) => ({
          color: palette.text.secondary,
          my: 1.25,
        })}
      />
      <Typography variant="body2">{explanation}</Typography>
    </ContentLoader>
  );
}
